var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDebugFlag = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.8 3a.6.6 0 1 0-1.2 0v.6c0 .476.14.92.378 1.294A3.6 3.6 0 0 0 7.2 8.4h-.6a1.8 1.8 0 0 1-1.8-1.8V4.2a.6.6 0 1 0-1.2 0v2.4a3 3 0 0 0 3 3h.6v1.8H3a.6.6 0 1 0 0 1.2h4.2v1.8h-.6a3 3 0 0 0-3 3v2.4a.6.6 0 1 0 1.2 0v-2.4a1.8 1.8 0 0 1 1.8-1.8h.6a4.8 4.8 0 1 0 9.6 0h.6a1.8 1.8 0 0 1 1.8 1.8v2.4a.6.6 0 1 0 1.2 0v-2.4a3 3 0 0 0-3-3h-.6v-1.8H21a.6.6 0 0 0 0-1.2h-4.2V9.6h.6a3 3 0 0 0 3-3V4.2a.6.6 0 1 0-1.2 0v2.4a1.8 1.8 0 0 1-1.8 1.8h-.6a3.6 3.6 0 0 0-2.778-3.506c.24-.372.378-.816.378-1.294V3a.6.6 0 1 0-1.2 0v.6a1.2 1.2 0 1 1-2.4 0zm4.8 5.4v7.2a3.6 3.6 0 1 1-7.2 0V8.4A2.4 2.4 0 0 1 10.8 6h2.4a2.4 2.4 0 0 1 2.4 2.4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDebugFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/debug-flag.aad2cedf.svg";